<template>
  <div class="home">
    <div class="top-white-box"></div>
    <div class="top-gray-box">
      <h1>Lists</h1>
    </div>
    <GiveawayBox />
    <Articles />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import Articles from '@/components/Articles.vue'
import GiveawayBox from '@/components/GiveawayBox.vue'
import settings from '@/settings'

export default defineComponent({
  name: 'Blog',
  components: {
    Articles,
    GiveawayBox
  },
  setup() {
    onMounted(() => {
      document.title = `${settings.siteNameCaps} | ${settings.siteNameCaps} Blog. Read all about deals on our product oriented blog.`
    })

    return {
      settings
    }
  }
})
</script>


<style scoped>

  .article-title-with-date {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  .article-author-date-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 50px;
    width: 100%;
  }

  .article-author {
    font-size: 14px;
    color: #666;
    font-weight: 600;
  }
</style>